import React, { useEffect, useState } from "react";
import "./IncomesApp.css";
import { ApiPaths } from "../../Config/ApiPath";
import useAxiosHelper from "../../Common/AxiosHelper";
import { setIncomeWallet } from "../../Redux/IncomeWallet";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../Components/PaginationControls/PaginationControls";
import { BasicInfo } from "../../Config/BasicInfo";
import coinLogo from "../../Images/coin.png";
import moment from "moment";
import {
  TrendingUp,
  Target,
  BarChart2,
  Wallet,
  DollarSign,
  Calendar,
  Clock,
  Gift,
  Crown,
  Search,
  SlidersHorizontal,
  X,
  RotateCcw,
  Inbox,
  ArrowDownLeft,
  Coins,
  Layers,
  Hourglass,
} from "lucide-react";
import { useLocation } from "react-router-dom";

const EMPTY_SEARCH = {
  level: "",
  from: "",
  startDate: "",
  endDate: "",
  fromname: "",
  rank: "",
  release: "",
  self_investment: "",
};

const sourceIcons = {
  roi_income: TrendingUp,
  roi_level_income: BarChart2,
  direct_income: Target,
  referral_income: Target,
  reward_income: Gift,
  royalty_income: Crown,
  token_income: Coins,
  decent_token: Coins,
};
const sourceTones = ["orange", "blue", "violet", "mint", "pink", "gold"];

const Incomes = () => {
  const { AxiosGet } = useAxiosHelper();
  const dispatch = useDispatch();
  const [companyData, setCompanyData] = useState([]);
  const incomeData = useSelector((state) => state.incomeData.incomeWallet);
  const location = useLocation();
  const { incomeSlug } = location.state || {};
  const incomeWallets =
    Array.isArray(incomeData) &&
    incomeData.filter((wallet) => wallet.wallet_type == "income");
  const [selectIncome, setSelectIncome] = useState("");

  const [filterVisiblity, setFilterVisiblity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalTokenIncome, setTotalTokenIncome] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paymentTransaction, setPaymentTransaction] = useState([]);
  const [currentIncome, setCurrentIncome] = useState("");
  const [limitFilter, setLimitFilter] = useState(10);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [search, setSearch] = useState(EMPTY_SEARCH);
  const [hasFetched, setHasFetched] = useState(false);

  const TOKEN_INCOME_SLUGS = ["token_income", "decent_token"];
  const isTokenIncomeSelected = TOKEN_INCOME_SLUGS.includes(selectIncome);

  const [activeTab, setActiveTab] = useState("overview");

  useEffect(() => {
    if (incomeSlug) {
      setActiveTab("history");
      setSelectIncome(incomeSlug);
    } else if (!selectIncome && !incomeSlug && incomeWallets?.length) {
      setSelectIncome(incomeWallets[0].slug);
    }
  }, [incomeWallets, incomeSlug]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const AddFilter = () => {
    fetchHistory();
    setFilterVisiblity(false);
  };

  var x = 0;
  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (x == 0) {
      fetchIncome();
      CompanyInfo();
      if (selectIncome) {
        fetchHistory();
      }
      x++;
    }
  }, [selectIncome, currentPage]);

  async function fetchIncome() {
    const res = await AxiosGet(ApiPaths.getWallets);
    if (res) {
      const wallets = res?.wallets || [];
      dispatch(setIncomeWallet(wallets));

      // Token income is paid in project tokens — keep USDT totals separate
      const tokenIncome = wallets
        .filter((w) => TOKEN_INCOME_SLUGS.includes(w?.slug))
        .reduce((sum, w) => sum + (parseFloat(w?.value) || 0), 0);
      const dollarTotal = (parseFloat(res?.totalIncome) || 0) - tokenIncome;

      setTotalIncome(dollarTotal > 0 ? dollarTotal : 0);
      setTotalTokenIncome(tokenIncome > 0 ? tokenIncome : 0);
    }
  }

  const selectSource = (slug) => {
    if (slug === selectIncome) return;
    setPaymentTransaction([]);
    setHasFetched(false);
    setSelectIncome(slug);
    setCurrentPage(1);
  };

  const handleChangeFilter = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  // shared by fetchHistory / resetData
  function buildQuery(searchState, limit) {
    const filteredSearch = Object.fromEntries(
      Object.entries(searchState).filter(([key, value]) => value !== "")
    );
    const baseQuery = {
      page: currentPage,
      limit,
      ...filteredSearch,
    };
    const queryParams = new URLSearchParams();
    Object.entries(baseQuery).forEach(([key, value]) => {
      queryParams.append(key, value);
    });
    if (selectIncome === "decent_token") {
      queryParams.append("source", "decent_token");
      queryParams.append("source", "token_withdrawal");
    } else if (selectIncome) {
      queryParams.append("source", selectIncome);
    }
    return queryParams.toString();
  }

  async function fetchHistory() {
    try {
      setLoading(true);
      const response = await AxiosGet(
        `${ApiPaths.getPaymentTransaction}?${buildQuery(search, limitFilter)}`
      );
      setCurrentIncome(response?.creditSum);
      setPaymentTransaction(response?.data || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      BasicInfo.isDebug &&
        console.error("Error fetching payment transactions:", error);
    } finally {
      setLoading(false);
      setHasFetched(true);
    }
  }

  async function CompanyInfo() {
    try {
      const data = localStorage.getItem("companyData");
      setCompanyData(JSON.parse(data));
    } catch (error) {
      BasicInfo.isDebug && console.log(error);
    }
  }

  async function resetData() {
    resetFilter();
    setFilterVisiblity(false);
    try {
      setLoading(true);
      const response = await AxiosGet(
        `${ApiPaths.getPaymentTransaction}?${buildQuery(EMPTY_SEARCH, 10)}`
      );
      setCurrentIncome(response?.creditSum);
      setPaymentTransaction(response?.data || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      BasicInfo.isDebug &&
        console.error("Error fetching payment transactions:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleLimitChange = (value) => {
    setLimitFilter(value);
  };

  function resetFilter() {
    setSearch(EMPTY_SEARCH);
    setLimitFilter(10);
    setCurrentPage(1);
  }

  const sourceName = () => {
    const name = incomeWallets?.find((x) => x?.slug === selectIncome);
    return name ? name.name : "";
  };

  // Keep the selected source card visible in the swipe row (incl. deep links)
  useEffect(() => {
    if (!selectIncome) return;
    const el = document.querySelector(`.icSource[data-slug="${selectIncome}"]`);
    el?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }, [selectIncome]);

  // Escape closes the filter sheet; page behind stays put
  useEffect(() => {
    if (!filterVisiblity) return undefined;
    const onKey = (e) => e.key === "Escape" && setFilterVisiblity(false);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey);
    };
  }, [filterVisiblity]);

  /* ---------- formatting ---------- */
  const money = (v) =>
    `$${(parseFloat(v) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const tokens = (v) => (parseFloat(v) || 0).toLocaleString("en-US", { maximumFractionDigits: 4 });
  const dt = (v) => (v ? moment(v).format("DD MMM YYYY, hh:mm A") : "—");
  const daysToRelease = () => {
    const nextMonth = moment().add(1, "months").startOf("month");
    const d = nextMonth.diff(moment(), "days");
    return d > 0 ? `${d} days` : "0 days";
  };

  const activeFilterCount =
    ["fromname", "from", "level", "release", "startDate", "endDate"].filter((k) => search[k] !== "" && search[k] !== undefined).length +
    (Number(limitFilter) !== 10 ? 1 : 0);
  const wallets = Array.isArray(incomeWallets) ? incomeWallets : [];
  const selectedIdx = Math.max(0, wallets.findIndex((w) => w.slug === selectIncome));
  const SelIcon = sourceIcons[selectIncome] || DollarSign;

  // Card content per income type — mirrors the old table's columns
  const describe = (x) => {
    const isToken = x?.source === "decent_token" || x?.source === "token_income" || isTokenIncomeSelected;
    let title;
    let subtitle;
    if (selectIncome === "roi_income") {
      title = "Daily ROI";
      subtitle = x?.user_package ? `On ${money(x.user_package)} package` : "Package return";
    } else if (selectIncome === "reward_income") {
      title = "Reward";
      subtitle = "Legacy reward income";
    } else if (selectIncome === "decent_token") {
      title = x?.source == "decent_token" ? "Package Active" : "Token Withdrawal";
      subtitle = "Token movement";
    } else {
      title = x?.fromname || x?.from || sourceName();
      subtitle = x?.from ? `@${x.from}` : sourceName();
    }

    const meta = [];
    if (selectIncome === "roi_income") {
      meta.push({ label: "Activated", value: dt(x?.order_Activation_date) });
      meta.push({ label: "ROI date", value: dt(x?.time) });
    }
    if (["roi_income", "roi_level_income", "royalty_income"].includes(selectIncome) && x?.income_percent !== undefined) {
      meta.push({ label: "Income", value: `${x.income_percent}%` });
    }
    if (["roi_level_income", "royalty_income"].includes(selectIncome) && x?.order_amount !== undefined) {
      meta.push({ label: "Order", value: money(x.order_amount) });
    }
    if (selectIncome === "roi_level_income" && x?.user_package !== undefined) {
      meta.push({ label: "User package", value: money(x.user_package) });
    }
    if (
      selectIncome !== "roi_income" &&
      !["royalty_income", "reward_income", "direct_income", "decent_token"].includes(selectIncome) &&
      x?.level !== undefined &&
      x?.level !== null
    ) {
      meta.push({ label: "Level", value: x.level, chip: true });
    }
    if (selectIncome === "reward_income") {
      meta.push({ label: "Release", value: x?.release === 1 ? dt(x?.updatedAt) : "—" });
      meta.push({ label: "Remaining", value: x?.release === 1 ? "Income Released" : daysToRelease() });
    }

    const amountMain = isToken ? tokens(x?.amount) : money(x?.amount);
    const amountHint =
      x?.order_amount != null && x?.order_amount != x?.amount && !["roi_level_income", "royalty_income"].includes(selectIncome)
        ? `/ ${money(x.order_amount)}`
        : "";
    const when = selectIncome === "roi_income" ? null : dt(x?.time);
    return { isToken, title, subtitle, meta, amountMain, amountHint, when };
  };

  const listLoading = loading && !paymentTransaction?.length;

  return (
    <section className="icPage">
      {/* ---------- Hero ---------- */}
      <div className="icHero">
        <div className="icHeroTop">
          <span className="icEyebrow">
            <Wallet size={13} /> Earnings
          </span>
          <div className="icClock">
            <span>
              <Calendar size={12} />
              {currentTime.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}
            </span>
            <span>
              <Clock size={12} />
              {currentTime.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}
            </span>
          </div>
        </div>
        <div className="icHeroLabel">Total income</div>
        <div className="icHeroValue">{money(totalIncome)}</div>
        <div className="icHeroChips">
          <span className="icTokenChip">
            <img src={coinLogo} alt="" />
            {tokens(totalTokenIncome)}
            <small>tokens earned</small>
          </span>
          <span className="icSourceCount">
            <Layers size={13} /> {wallets.length} income sources
          </span>
        </div>
      </div>

      {/* ---------- Income sources ---------- */}
      {wallets.length > 0 && (
        <div className="icSources" role="tablist" aria-label="Income sources">
          {wallets.map((w, i) => {
            const Icon = sourceIcons[w.slug] || DollarSign;
            const tone = sourceTones[i % sourceTones.length];
            const isTok = TOKEN_INCOME_SLUGS.includes(w.slug);
            const on = w.slug === selectIncome;
            return (
              <button
                key={w.slug}
                data-slug={w.slug}
                type="button"
                role="tab"
                aria-selected={on}
                className={`icSource tone-${tone} ${on ? "isOn" : ""}`}
                onClick={() => selectSource(w.slug)}
              >
                <span className="icSourceIcon">
                  <Icon size={18} />
                </span>
                <span className="icSourceName">{w.name}</span>
                <span className="icSourceValue">
                  {isTok ? (
                    <>
                      <img src={coinLogo} alt="" /> {tokens(w.value)}
                    </>
                  ) : (
                    money(w.value)
                  )}
                </span>
              </button>
            );
          })}
        </div>
      )}

      {/* ---------- History ---------- */}
      <div className="icHistory">
        <div className={`icHistHead tone-${sourceTones[selectedIdx % sourceTones.length]}`}>
          <span className="icHistIcon">
            <SelIcon size={20} />
          </span>
          <div className="icHistTitle">
            <b>{sourceName() || "Income"}</b>
            <small>
              {currentIncome !== undefined && currentIncome !== "" && currentIncome !== null
                ? <>Credited {isTokenIncomeSelected ? tokens(currentIncome) : money(currentIncome)}</>
                : "Transaction history"}
            </small>
          </div>
          <button
            type="button"
            className={`icFilterBtn ${activeFilterCount ? "isOn" : ""}`}
            onClick={() => setFilterVisiblity(true)}
            aria-label="Filters"
          >
            <SlidersHorizontal size={18} />
            {activeFilterCount > 0 && <i>{activeFilterCount}</i>}
          </button>
        </div>

        {paymentTransaction === null ? (
          <div className="icEmpty">
            <span>
              <Inbox size={26} />
            </span>
            <b>Failed to load income history</b>
            <small>Invalid or expired token</small>
          </div>
        ) : listLoading || (!hasFetched && selectIncome) ? (
          <div className="icList">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="icTxn icSkel">
                <span className="icSkelDot" />
                <span className="icSkelLines">
                  <span className="w60" />
                  <span className="w40" />
                </span>
                <span className="icSkelAmt" />
              </div>
            ))}
          </div>
        ) : paymentTransaction.length === 0 ? (
          <div className="icEmpty">
            <span>
              <Inbox size={26} />
            </span>
            <b>No history yet</b>
            <small>
              {activeFilterCount
                ? "Nothing matches your filters."
                : `${sourceName() || "This income"} will appear here once it's credited.`}
            </small>
            {activeFilterCount > 0 && (
              <button type="button" onClick={() => resetData()}>
                <RotateCcw size={14} /> Clear filters
              </button>
            )}
          </div>
        ) : (
          <div className={`icList ${loading ? "isBusy" : ""}`}>
            {paymentTransaction.map((x, i) => {
              const d = describe(x);
              const success = x.release === 1;
              return (
                <div className="icTxn" key={x?._id || i}>
                  <div className="icTxnMain">
                    <span className={`icTxnIcon ${d.isToken ? "token" : ""}`}>
                      {d.isToken ? <img src={coinLogo} alt="" /> : <ArrowDownLeft size={18} />}
                    </span>
                    <span className="icTxnText">
                      <b>{d.title}</b>
                      <small>{d.subtitle}</small>
                    </span>
                    <span className="icTxnAmt">
                      <b className={d.isToken ? "token" : ""}>+{d.amountMain}</b>
                      {d.amountHint && <small>{d.amountHint}</small>}
                    </span>
                  </div>

                  {d.meta.length > 0 && (
                    <div className="icTxnMeta">
                      {d.meta.map((m) => (
                        <span key={m.label} className={m.chip ? "chip" : ""}>
                          <small>{m.label}</small>
                          {m.value}
                        </span>
                      ))}
                    </div>
                  )}

                  <div className="icTxnFoot">
                    <span className="icTxnNo">#{(currentPage - 1) * limitFilter + (i + 1)}</span>
                    {d.when && (
                      <span>
                        <Clock size={12} /> {d.when}
                      </span>
                    )}
                    <span className={`icStatus ${success ? "ok" : "wait"}`}>
                      {success ? "Success" : <><Hourglass size={11} /> Pending</>}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {paymentTransaction != null && paymentTransaction.length > 0 && (
          <div className="icPager">
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePagination}
            />
          </div>
        )}
      </div>

      {/* ---------- Filter sheet ---------- */}
      {filterVisiblity && (
        <div className="icSheetOverlay" onClick={() => setFilterVisiblity(false)}>
          <div className="icSheet" role="dialog" aria-modal="true" aria-labelledby="icFilterTitle" onClick={(e) => e.stopPropagation()}>
            <span className="icHandle" aria-hidden="true" />
            <div className="icSheetHead">
              <h3 id="icFilterTitle">Filter {sourceName() || "income"}</h3>
              <button type="button" className="icClose" onClick={() => setFilterVisiblity(false)} aria-label="Close">
                <X size={18} />
              </button>
            </div>

            <div className="icFieldRow">
              <label className="icField">
                <span>From name</span>
                <input type="text" name="fromname" placeholder="Name" value={search.fromname} onChange={handleChangeFilter} />
              </label>
              <label className="icField">
                <span>From user ID</span>
                <input
                  type="text"
                  name="from"
                  placeholder="User ID"
                  value={search.from}
                  onChange={handleChangeFilter}
                  autoCapitalize="characters"
                  autoCorrect="off"
                />
              </label>
            </div>
            <div className="icFieldRow">
              <label className="icField">
                <span>From date</span>
                <input type="date" name="startDate" value={search.startDate} onChange={handleChangeFilter} />
              </label>
              <label className="icField">
                <span>To date</span>
                <input type="date" name="endDate" value={search.endDate} onChange={handleChangeFilter} />
              </label>
            </div>
            <label className="icField">
              <span>Level</span>
              <input type="number" inputMode="numeric" name="level" placeholder="Any level" value={search.level} onChange={handleChangeFilter} />
            </label>
            <div className="icField">
              <span>Status</span>
              <div className="icSeg">
                {[
                  { label: "All", value: "" },
                  { label: "Success", value: "1" },
                  { label: "Pending", value: "0" },
                ].map((s) => (
                  <button
                    key={s.label}
                    type="button"
                    className={search.release === s.value ? "isOn" : ""}
                    onClick={() => setSearch((p) => ({ ...p, release: s.value }))}
                  >
                    {s.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="icField">
              <span>Per page</span>
              <div className="icSeg">
                {[10, 20, 50, 100, 200].map((n) => (
                  <button
                    key={n}
                    type="button"
                    className={Number(limitFilter) === n ? "isOn" : ""}
                    onClick={() => handleLimitChange(n)}
                  >
                    {n}
                  </button>
                ))}
              </div>
            </div>

            <div className="icSheetActions">
              <button type="button" className="icBtn ghost" onClick={() => resetData()}>
                <RotateCcw size={16} /> Reset
              </button>
              <button type="button" className="icBtn primary" onClick={AddFilter}>
                <Search size={16} /> Show results
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Incomes;
